import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuFipsAppResource from "./LuFipsAppResource";
import LuLoanTypeAppResource from "./LuLoanTypeAppResource";
import LuFinTypeAppResource from "./LuFinTypeAppResource";

class AssessorRecordAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'fa-assessor-record';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'assessors/records';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'fips',
            'propertyId',
            'apn',
            'totalOpenLienNbr',
            'totalOpenLienAmt',
            'mtg1TransactionId',
            'mtg1RecordingDate',
            'mtg1LoanAmt',
            'mtg1Lender',
            'mtg1PrivateLender',
            'mtg1Term',
            'mtg1LoanDueDate',
            'mtg1AdjRider',
            'mtg1LoanType',
            'mtg1FinType',
            'mtg1LienPosition',
            'mtg2TransactionId',
            'mtg2RecordingDate',
            'mtg2LoanAmt',
            'mtg2Lender',
            'mtg2PrivateLender',
            'mtg2Term',
            'mtg2LoanDueDate',
            'mtg2AdjRider',
            'mtg2LoanType',
            'mtg2FinType',
            'mtg2LienPosition',
            'mtg3TransactionId',
            'mtg3RecordingDate',
            'mtg3LoanAmt',
            'mtg3Lender',
            'mtg3PrivateLender',
            'mtg3Term',
            'mtg3LoanDueDate',
            'mtg3AdjRider',
            'mtg3LoanType',
            'mtg3FinType',
            'mtg3LienPosition',
            'mtg4TransactionId',
            'mtg4RecordingDate',
            'mtg4LoanAmt',
            'mtg4Lender',
            'mtg4PrivateLender',
            'mtg4Term',
            'mtg4LoanDueDate',
            'mtg4AdjRider',
            'mtg4LoanType',
            'mtg4FinType',
            'mtg4LienPosition',
            'faTimeStamp',
            'faRecordType',
            'mtg1EstLoanBalance',
            'mtg2EstLoanBalance',
            'mtg3EstLoanBalance',
            'mtg4EstLoanBalance',
            'cltv',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            luFips: LuFipsAppResource,
            mtg1LuLoanType: LuLoanTypeAppResource,
            mtg2LuLoanType: LuLoanTypeAppResource,
            mtg3LuLoanType: LuLoanTypeAppResource,
            mtg4LuLoanType: LuLoanTypeAppResource,
            mtg1LuFinType: LuFinTypeAppResource,
            mtg2LuFinType: LuFinTypeAppResource,
            mtg3LuFinType: LuFinTypeAppResource,
            mtg4LuFinType: LuFinTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            luFips: 'fips',
            mtg1LuLoanType: 'mtg_1_loan_type',
            mtg2LuLoanType: 'mtg_2_loan_type',
            mtg3LuLoanType: 'mtg_3_loan_type',
            mtg4LuLoanType: 'mtg_4_loan_type',
            mtg1LuFinType: 'mtg_1_fin_type',
            mtg2LuFinType: 'mtg_2_fin_type',
            mtg3LuFinType: 'mtg_3_fin_type',
            mtg4LuFinType: 'mtg_4_fin_type',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default AssessorRecordAppResource;
